import React from "react";
import "draft-js/dist/Draft.css";
import { Editor, EditorState, convertFromRaw } from "draft-js";

interface AddDescriptionResponseProps {
  response: {
    descriptionName?: string;
  };
  label: string;
}

const AddDescriptionResponse: React.FC<AddDescriptionResponseProps> = ({ response }) => {
  let editorState;

  try {
    if (response.descriptionName) {
      const contentState = convertFromRaw(JSON.parse(response.descriptionName));
      editorState = EditorState.createWithContent(contentState);
    } else {
      editorState = EditorState.createEmpty();
    }
  } catch (error) {
    editorState = EditorState.createEmpty();
  }

  const customStyleMap = {
    BOLD: { fontWeight: "bold" },
    UNDERLINE: { textDecoration: "underline" },
  };

  const blockStyleFn = (block: any) => {
    switch (block.getType()) {
      case "header-four":
        return "custom-header-four";
      case "header-five":
        return "custom-header-five";
      case "header-six":
        return "custom-header-six";
      default:
        return "";
    }
  };

  return (
    <div className="mb-4 text-sm text-[#494C52] description-content">
      {/* @ts-ignore */}
      <Editor
        editorState={editorState}
        readOnly={true}
        onChange={() => {}}
        customStyleMap={customStyleMap}
        blockStyleFn={blockStyleFn}
      />
    </div>
  );
};

export default AddDescriptionResponse;
